import React from "react";
import { Typography } from "@mui/material";
import { MONO_FONT } from "@/shared/typography";

interface MicroLabelProps {
  children: React.ReactNode;
  "data-testid"?: string;
}

export function MicroLabel({ children, "data-testid": dataTestId }: MicroLabelProps) {
  return (
    <Typography
      component="span"
      data-testid={dataTestId}
      sx={{
        fontSize: 10,
        fontFamily: MONO_FONT,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "text.disabled",
      }}
    >
      {children}
    </Typography>
  );
}